export default __webpack_public_path__ + "static/media/Electrophoresis_Box.1d0a724c.svg";